module.exports = __webpack_public_path__ + "img/defense-2018-doctor.15658451.jpg";